/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: tree-utils.tsx
 * Project: mle-client
 * Committed last: 2021/11/12 @ 826
 * ---
 */

import { Tree, TreeNodeInfo } from '@blueprintjs/core';
import { cloneDeep }          from 'lodash';
import React                  from 'react';

/**
 * Funzionalità riadattate da codice open source.
 * Vedi https://github.com/palantir/blueprint/blob/develop/packages/docs-app/src/examples/core-examples/treeExample.tsx
 */

export type NodePath = number[];

export type TreeAction =
  | { type: 'SET_IS_EXPANDED'; payload: { path: NodePath; isExpanded: boolean } }
  | { type: 'DESELECT_ALL' }
  | { type: 'SET_IS_SELECTED'; payload: { path: NodePath; isSelected: boolean } };

export const forEachNode = (nodes: TreeNodeInfo[] | undefined, callback: (node: TreeNodeInfo) => void) => {
  if (nodes === undefined)
    return;

  for (const node of nodes) {
    callback(node);
    forEachNode(node.childNodes, callback);
  }
};

export const forNodeAtPath = (nodes: TreeNodeInfo[], path: NodePath, callback: (node: TreeNodeInfo) => void) => {
  callback(Tree.nodeFromPath(path, nodes));
};

export enum EntitiesTreeActionTypes {
  DESELECT_ALL,
  SET_IS_EXPANDED,
  SET_IS_SELECTED,
  UPDATE_NODES
}

export const entitiesTreeReducer = (state: TreeNodeInfo[], action: any) => {
  switch (action.type) {
    case EntitiesTreeActionTypes.DESELECT_ALL:
      const newState1 = cloneDeep(state);
      forEachNode(newState1, node => (node.isSelected = false));
      return newState1;
    case EntitiesTreeActionTypes.SET_IS_EXPANDED:
      const newState2 = cloneDeep(state);
      forNodeAtPath(newState2,
        action.payload.path,
        node => (node.isExpanded = action.payload.isExpanded));
      return newState2;
    case EntitiesTreeActionTypes.SET_IS_SELECTED:
      const newState3 = cloneDeep(state);
      forNodeAtPath(newState3,
        action.payload.path,
        node => (node.isSelected = action.payload.isSelected));
      return newState3;
    case EntitiesTreeActionTypes.UPDATE_NODES:
      return action.payload;
    default:
      return state;
  }
};



